import {Loader} from "@mantine/core";
import style from './Loader.module.css';


interface LoaderIndicatorProps {
  id: string,
  message?: string,
  strokeWidth?: string,
}
export default function LoaderIndicator({id, message}: LoaderIndicatorProps) {
  return <div className={style.wrapper}><Loader id={id} size="lg" /><div className={style.message}>{message}</div></div>;
}
